// extracted by mini-css-extract-plugin
module.exports = {"PurchaseFormErrorMessage":"PurchaseFormErrorMessage_PurchaseFormErrorMessage__3oV0c"};